import Subscribe from '@src/resources/Subscribe';

export const redirect = (basePath: string, id: string, data: any) =>
  `/${Subscribe.name}/${data.package_id}/show/prices`;
